import React, { useCallback, useEffect, useState } from 'react'
import Container from "react-bootstrap/Container"
import Table from "react-bootstrap/Table"
import configuredAxios from '../../configured-axios'
import { ADD_ADMIN_RUN, CONTAINER_RUNS_URL, REMOVE_RUN } from '../api_urls'
import { ArrowRight, Plus, Trash } from 'react-bootstrap-icons'
import TablePaginator from '../common/TablePaginator'
import LocationDataSelectInput from '../locations/LocationDataSelectInput'
import { Button, Col, Modal, Row } from 'react-bootstrap'
import Select from 'react-select'
import { toast } from 'react-toastify'

function getContainerMovement(run, containerId) {
  const customer = run.location !== null ? run.location.customer.name : "Unknown"
  const nickname = run.location !== null && run.location.nickname ? ` (${run.location.nickname})` : ''
  const location = run.location !== null && run.location.address !== null ? run.location.address + nickname : "Unknown"
  if (Number(run.pickUpId) === Number(containerId) && Number(run.dropOffId) === Number(containerId)) {
    return <>
    <b>Picked Up: </b>{customer} <ArrowRight /> MGE
    <br />
    <b>Dropped Off: </b>MGE <ArrowRight /> {customer}
    <br />
    Location: {location}
  </>
  } else if (Number(run.pickUpId) === Number(containerId)) {
    return <>
    <b>Picked Up: </b>{customer} <ArrowRight /> MGE
    <br />
    Location: {location}
  </>
  } else {
    return <>
    <b>Dropped Off: </b>MGE <ArrowRight /> {customer}
    <br />
    Location: {location}
  </>
  }
}

function ContainerRunList({ containerId, containerRunsChanged }) {
  const [runs, setRuns] = useState([])
  const [totalruns, setTotalRuns] = useState(0)
  const [runsPerPage, setRunsPerPage] = useState(20)
  const [runsOffest, setRunsOffset] = useState(0)
  const [selectedLocation, setSelectedLocation] = useState(undefined)
  const [locationUnknown, setLocationUnknown] = useState(false)
  const [pickupOrDropoff, setPickupOrDropoff] = useState({ label: 'Pick up', value: 'pickup' })
  const [showForm, setShowForm] = useState(false)
  const [showDeleteModal, setShowDeleteModal] = useState(false)
  const [runToDelete, setRunToDelete] = useState(undefined)

  const refreshRunList = useCallback((runsChanged) => {
    const queryParams = new URLSearchParams({ limit: runsPerPage, offset: runsOffest })
    configuredAxios.get(CONTAINER_RUNS_URL + "/" + containerId + "?" + queryParams.toString()).then((res) => {
      setRuns(res.data.runs)
      setTotalRuns(res.data.totalCount)
    })
    if (runsChanged) {
      containerRunsChanged()
    }
  }, [containerId, containerRunsChanged, runsPerPage, runsOffest])

  useEffect(() => {
    refreshRunList(false)
  }, [refreshRunList])

  const runTableRows = []
  for (const run of runs) {
    let rowStyle = {}
    if (!run.complete) {
      rowStyle = { backgroundColor: 'lightyellow' }
    }
    runTableRows.push(<tr key={run.id} style={rowStyle}>
      <td>{run.daily_run !== null ? (new Date(run.daily_run.date)).toLocaleDateString() : "Admin Run"}</td>
      <td>
        {run.daily_run !== null ? <a href={"/run/" + run.daily_run.id}>{run.daily_run.code}</a> : "Admin Run"} ({run.id})
      </td>
      <td>{run.daily_run !== null ? run.daily_run.truck.number : "Admin Run"}</td>
      <td>{getContainerMovement(run, containerId)}</td>
      <td>{run.complete ? "Yes" : "No"}</td>
      <td>{run.complete ? (new Date(run.updatedAt)).toLocaleDateString() : ""}</td>
      <td><Button variant='outline-danger' onClick={() => {
        setShowDeleteModal(true)
        setRunToDelete(run.id)
      }} ><Trash /></Button></td>
    </tr>)
  }

  const handleCreateAdminRunPressed = () => {
    const req = {
      type: pickupOrDropoff.value,
      containerId: Number(containerId)
    }
    if (!locationUnknown) {
      req['locationId'] = selectedLocation
    }
    const params = new URLSearchParams(req)
    console.log(params.toString())
    configuredAxios.post(ADD_ADMIN_RUN + "?" + params.toString()).then(() => {
      refreshRunList(true)
    }).catch(() => {
      toast.error('An error occurred while creating the admin run.')
    })
  }

  return <>
    <Container>
        <h4>
          Run History&nbsp;
          <Plus onClick={() => setShowForm(!showForm)} />
        </h4>
        
              
        {showForm && (
          <>
            <p className='mb-0 mt-3'><b>Add Admin Run</b></p>
            <Container className='mt-2'>
              <Row className='mb-2 pl-0'>
                <Col xs={3} className='pl-0'>
                  <label>Pickup or Dropoff</label>
                  <br />
                  <Select
                    options={[
                      { label: 'Pick up', value: 'pickup' },
                      { label: 'Drop off', value: 'dropoff' },
                    ]}
                    value={pickupOrDropoff}
                    onChange={(selected) => { setPickupOrDropoff(selected) }}
                  />
                </Col>
              </Row>
              <Row className='align-items-center'>
                <LocationDataSelectInput
                  isDisabled={locationUnknown}
                  className='pl-0'
                  label='Location'
                  name='locationId'
                  value={selectedLocation}
                  handleChange={(_name, value) => { setSelectedLocation(value) }}
                />
                <Col className='mt-4'>
                  <input
                    type='checkbox'
                    aria-label='Location Unknown'
                    className='mr-2'
                    defaultChecked={locationUnknown}
                    onChange={() => { setLocationUnknown(!locationUnknown) }}
                  />
                  <label>Location Unknown</label>
                </Col>
              </Row>
              <Row>
                <Button
                  variant='primary'
                  disabled={!locationUnknown && selectedLocation === undefined}
                  onClick={() => { handleCreateAdminRunPressed() }}
                >Create Admin Run</Button>
              </Row>
            </Container>
          </>
        )}
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <TablePaginator
            className='mt-2'
            onFirstPage={() => {
              setRunsOffset(0)
            }}
            onNextPage={() => {
              setRunsOffset(runsOffest + runsPerPage)
            }}
            onPreviousPage={() => {
              let newOffset = runsOffest - runsPerPage
              if (newOffset < 0) {
                newOffset = 0
              }
              setRunsOffset(newOffset)
            }}
            onLastPage={() => {
              setRunsOffset(totalruns - runsOffest)
            }}
            onItemsPerPageSelect={(selection) => { setRunsPerPage(selection) }}
            itemsPerPage={runsPerPage}
            totalItems={totalruns}
            offset={runsOffest}
          />
        </div>
        <Table bordered className='mt-2'>
          <thead>
            <tr>
              <th>Daily Run Date</th>
              <th>Daily Run</th>
              <th>Truck</th>
              <th>Container Movement</th>
              <th>Completed?</th>
              <th>Completed Date</th>
              <th className='text-center'><Trash /></th>
            </tr>
          </thead>
          <tbody>
            {
              runTableRows.length > 0 ?
              runTableRows :
              <tr>
                <td colSpan="7">No Runs Found</td>
              </tr>
            }
          </tbody>
        </Table>
    </Container>
    <Modal show={showDeleteModal}>
      <Modal.Body>
        Are you sure you want to delete run: {runToDelete}?
        <br />
        <br />
        This cannot be undone.
      </Modal.Body>
      <Modal.Footer>
        <Button variant='danger' onClick={() => {
          configuredAxios.delete(REMOVE_RUN + "/" + runToDelete).then(() => {
            refreshRunList(true)
            setShowDeleteModal(false)
            toast.success('Successfully removed container run.')
          }).catch(() => {
            toast.error('An error occurred while removing the container run.')
          })
        }}>Delete</Button>
        <Button variant='dark' onClick={() => {
          setRunToDelete(undefined)
          setShowDeleteModal(false)
        }}>Cancel</Button>
      </Modal.Footer>
    </Modal>
  </>
}

export default ContainerRunList
